<template>
    <div id="shduleBatch">
        <a-modal
                title="Batch"
                :visible="visible"
                @cancel	="cancel"
                width="45%"
        >
            <template slot="footer">
                <a-button size="small" type="primary" @click="saveBatch">Save</a-button>
            </template>
            <a-form :form="form">
                <a-row>
                    <a-col :span="8" :offset="3">
                        <a-form-item label="Schedule Name" class="genericFrom">
                            <a-input
                                    size="small"
                                    v-decorator="[
                                    'schdName',
                                    {
                                    initialValue: fromInitVal.schdName,
                                    rules: [
                                        {
                                          required: true,
                                          message: $t('publicLang.Required')
                                        },
                                      ],}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="3">
                        <a-form-item label="Monitor Type" class="genericFrom">
                            <a-input disabled size="small" v-decorator="['monitorType',{initialValue: fromInitVal.monitorType}]" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="3">
                        <a-form-item label="Schedule Type" class="genericFrom">
                            <a-input  disabled size="small" v-decorator="['schdType',{initialValue: fromInitVal.schdType}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="3">
                        <a-form-item label="Email Subject" class="genericFrom">
                            <a-input size="small" v-decorator="['emailSubject',{initialValue: fromInitVal.emailSubject}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="3">
                        <a-form-item label="Email To" class="genericFrom">
                            <a-input size="small" v-decorator="['emailTo',{initialValue: fromInitVal.emailTo}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="3">
                        <a-form-item label="Email Cc" class="genericFrom">
                            <a-input size="small" v-decorator="['emailCc',{initialValue: fromInitVal.emailCc}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="3">
                        <a-form-item label="Exp Monitor Time" class="genericFrom">
                            <a-date-picker
                                    size="small"
                                    allowClear
                                    showTime
                                    v-decorator="['expTime',{initialValue: fromInitVal.expTime !=null ? moment(fromInitVal.expTime, 'YYYY-MM-DD HH:mm:ss') : null}]"/>
                        </a-form-item>
                    </a-col>

                    <a-col :span="8" :offset="3">
                        <a-form-item label="SQL" class="genericFrom">
                            <a-textarea placeholder="Basic usage" :rows="2"  v-decorator="['sql',{initialValue: fromInitVal.sql}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8" :offset="3">
                        <a-form-item label=" Email Template" class="genericFrom">
                            <a-textarea placeholder="Basic usage" :rows="2" v-decorator="['emailTml',{initialValue: fromInitVal.emailTml}]"/>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import moment from 'moment'
    export default{
        data(){
            return{
                visible: false,
                form:this.$form.createForm(this),
                fromInitVal: {},
                transmitVal: {},// 转递过来的值 uid
            }
        },
        methods:{
            moment,
            show(val){
                this.visible = true
                this.form.resetFields();
                this.transmitVal = val
                ajax.post(api.SCHEDULEBATCH,{uids:val.arr}).then(res=>{
                    this.fromInitVal = res.data
                })
            },
            cancel(){
                this.visible = false
            },
            saveBatch(){
                this.form.validateFields((error, values)=>{
                    if(!error){
                        let params = values
                        params.uids = this.transmitVal.arr
                        params.expTime =  params['expTime'].format('YYYY-MM-DD HH:mm:ss')
                        ajax.post(api.SCHEDULEBATCHSAVE,params).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);

                                this.visible = false
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            }
        }
    }
</script>